// Updated Login.js - เพิ่ม Modal สำหรับ "ลืมรหัสผ่าน"
import { useState } from "react";
import {
  Box, Button, Input, FormControl, FormLabel, Heading,
  Alert, AlertIcon, Grid, GridItem, Image, Text,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, useDisclosure
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure(); // Hook สำหรับควบคุม Modal
  const API = process.env.REACT_APP_API_URL || "";

  const handleLogin = async () => {
    setError("");
    try {
      const res = await fetch(`${API}/api/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await res.json();
      if (!res.ok) {
        setError(data.error || "Login failed");
        return;
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("currentUser", JSON.stringify(data.user));
      navigate("/menu");
    } catch (err) {
      setError("Network error");
    }
  };

  return (
    <>
      <Box
        maxW={{ base: "100%", md: "3xl", lg: "6xl" }}
        mt={{ base: 4, md: 8, lg: 10 }}
        mx="auto"
        borderWidth={1}
        borderRadius="2xl"
        boxShadow="xl"
        h="max-content"
        overflow="hidden"
      >
        <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}>
          <GridItem
            display="flex"
            alignItems="center"
            justifyContent="center"
            bgImage={{ base: "url('bglogin.png')", md: "url('bglogin.png')" }}
            bgSize="cover"
            bgPosition="center"
          >
            <Image src="/neediss-evl-logo-circle.png" p={10} w="250px" />
          </GridItem>
          <GridItem
            bg="white"
            p={{ base: 4, md: 6 }}
            display="flex"
            alignItems="center"
            justifyContent="center"
            mt={10} mb={10}
          >
            <Box w="100%">
              <Heading mb={4}>Login</Heading>
              {error && (
                <Alert status="error" mb={4}>
                  <AlertIcon />
                  {error}
                </Alert>
              )}
              <FormControl mb={3}>
                <FormLabel>Username</FormLabel>
                <Input
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </FormControl>
              <FormControl mb={5}>
                <FormLabel>Password</FormLabel>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </FormControl>
              <Button onClick={handleLogin} colorScheme="blue" w="full" mb={5}>
                Login
              </Button>
              <Text
                as="button"
                onClick={onOpen}
                fontSize="sm"
                color="blue.500"
                _hover={{ textDecoration: "underline" }}
                mb={4}
                display="block"
                textAlign="right"
              >
                ลืมรหัสผ่าน
              </Text>
            </Box>
          </GridItem>
        </Grid>
      </Box>

      {/* Modal ลืมรหัสผ่าน */}
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>ลืมรหัสผ่าน</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Text>กรุณาติดต่อ Admin ที่ Contact Center 081-613-7665</Text>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              ปิด
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}